<template>
  <v-container>
    Homepage
  </v-container>
</template>

<script>
export default {

}
</script>
